const vars = {
    // Media
    breakpoints: {
        xsMobile: 325,
        sMobile: 375,
        mobile: 450,
        mMobile: 550,
        lMobile: 650,
        mTablet: 768,
        tablet: 1024,
        sDesktop: 1366,
        mDesktop: 1440,
    },
    // Fonts
    fonts: {
        Roboto: "'Roboto', Arial, sans-serif",
    },
    // Colors
    theme: {
        black: '#1A1C21',
        red: '#F15045',
        outlineGrey: '#E1E8F2',
        darkGrey: '#5C6A79',
        grey: '#B5BFCD',
        lightGrey: '#F0F4FA',
        darkBlue: '#183B56',
        blue: '#2D6EEE',
    },
}

export default vars
